import React, { useEffect, useState } from 'react';
import './Vehicles.css';
import Sidebar from '../Header&SIdebar/sidebar';
import axios from 'axios';
import AddModalVehicles from './AddModalVehicles'; // Импортируйте ваш новый компонент

const Vehicles = () => {
  const [vehicles, setVehicles] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false); // Состояние для управления модальным окном

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}v1/Vehicles/`, {
        headers: {
          'x-api-key': '12345xxa',
        },
      })
      .then((res) => {
        setVehicles(res.data);
      })
      .catch((error) => {
        console.error('Ошибка при получении данных о заказах:', error);
      });
  }, []);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const filteredVehicles = vehicles.filter(vehicle =>
    vehicle.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleAddClick = () => {
    setIsModalOpen(true); // Открыть модальное окно
  };

  const handleCloseModal = () => {
    setIsModalOpen(false); // Закрыть модальное окно
  };

  return (
    <div className="vehicles-container">
      <div className="vehicles-sidebar-content">
        <Sidebar />
      </div>
      <div className="vehicles-basic-content">
        <h2 className="vehicles-zagolovok">Машины</h2>
        <div className="vehicles-header">
          <input
            type="text"
            placeholder="Поиск по наименованию..."
            value={searchTerm}
            onChange={handleSearchChange}
            className="search-input-vehicles"
          />
          <button className="vehicles-button-dobavit" onClick={handleAddClick}>
            Добавить
          </button>
        </div>
        <div className="vehicles-list">
          {filteredVehicles.map((vehicle) => (
            <div key={vehicle.id} className="vehicle-card">
              <div className="vehicle-info">
                <span className="vehicle-name">{vehicle.name}</span>
                <span className="vehicle-number">{vehicle.registration_number}</span>
                <a href={vehicle.certificate} target="_blank" rel="noopener noreferrer">
                  <img src="path-to-icon" alt="Сертификат" className="certificate-icon" />
                </a>
              </div>
              <button className="vehicles-button-udalit">Удалить</button>
            </div>
          ))}
        </div>
      </div>
      <AddModalVehicles isOpen={isModalOpen} onClose={handleCloseModal} /> {/* Добавьте модальное окно */}
    </div>
  );
};

export default Vehicles;
